import { cn } from "@omni/utils/styles";
import { ReactNode, Ref } from "react";

type Props = {
    ref?: Ref<HTMLDivElement | null>;
    className?: string;
    children: ReactNode;
};

export const Content = ({ className, children, ref, ...attributes }: Props) => {
    return (
        <div
            className={cn("tw:grow tw:p-4 tw:overflow-auto", className)}
            ref={ref}
            {...attributes}
        >
            {children}
        </div>
    );
};
